$shm_hitalama_map_catalog $shm_hitalama_entity_catalog
	menu_title \Карты
	maps_list_visible? true
	param \map
	title_default \Новая карта
	Page* $shm_hitalama_map_page
		entity <= entity*
	Book* $shm_hitalama_map_book
		entity <= entity*
	add_map* null
	menu_item_content* /$mol_view
		<= Menu_link*
		<= Favorite_action* $mol_view
			attr *
				^
				favorite <= map_favorite* false
			sub /
				<= Favorite* $mol_button_minor
					attr *
						^
						favorite <= map_favorite* false
					hint <= favorite_hint* \
					event_click? <=> favorite_toggle*? null
					sub /
						<= Favorite_icon* $mol_icon_star
		<= Editor_mode_action* $mol_view
			attr *
				^
				editor <= editor_mode_current* false
			sub /
				<= Editor_mode* $mol_link
					attr *
						^
						editor <= editor_mode_current* false
					hint \Открыть редактор
					sub /
						<= Editor_mode_icon* $mol_icon_code_braces
					arg <= editor_mode_link* *
	menu_link_content* /$mol_view_content
		^ public_icon_visible* / <= Public_icon* $mol_icon_earth
		<= Menu_link_title* $mol_dimmer
			needle <= menu_filter
			haystack <= spread_title*
	menu_body /
		<= Map_menu_links
	Map_menu_links $mol_view
		sub <= map_menu_links /$mol_view
	menu_head /$mol_view_content
		<= List_head $shm_list_head
			title <= menu_title
			add_content /
				<= Add_map $mol_pop_over
					align \right_bottom
					Anchor <= Add_map_anchor $mol_button_minor
						sub /
							<= Add_map_icon $mol_icon_plus
							\Добавить
					bubble_content /
						<= Add_map_menu $mol_list
							sub /
								<= Add_private $mol_button_minor
									click? <=> add_map*private? null
									sub /
										<= Add_private_icon $mol_icon_plus
										\Приватная карта
								<= Add_public $mol_button_minor
									click? <=> add_map*public_read? null
									sub /
										<= Add_public_icon $mol_icon_plus
										\Публичная карта
								<= Add_public_edit $mol_button_minor
									click? <=> add_map*public_edit? null
									sub /
										<= Add_public_edit_icon $mol_icon_plus
										\Публичная редактируемая карта
								<= Import $shm_hitalama_attach
									attach_title \Импорт из файла
									attach_new? <=> import? null
			close? <=> close_maps_list? null
			filter? <=> menu_filter? \
			sort_order? => sort_order?
			sort_by? <=> sort_by? \
